import { Check, Circle } from 'lucide-react';

import { Checkbox } from '../../primitives/Checkbox';

interface NoteDoneControlProps {
  done: boolean;
  /** True when the caller may tick the item. Otherwise a static marker shows. */
  canToggle: boolean;
  onToggle: () => void;
  busy: boolean;
}

/** An action item's done state: a checkbox to change it, or a plain marker to read it. */
export function NoteDoneControl({ done, canToggle, onToggle, busy }: NoteDoneControlProps) {
  if (canToggle) {
    return (
      <Checkbox
        checked={done}
        disabled={busy}
        onChange={onToggle}
        ariaLabel={done ? 'Reopen task' : 'Mark task done'}
      />
    );
  }
  const Icon = done ? Check : Circle;
  return (
    <span
      role="img"
      aria-label={done ? 'Done' : 'Open'}
      style={{
        display: 'inline-flex',
        width: 16,
        height: 16,
        alignItems: 'center',
        justifyContent: 'center',
        color: done ? 'var(--nb-primary)' : 'var(--nb-muted)',
      }}
    >
      <Icon size={done ? 14 : 12} aria-hidden="true" />
    </span>
  );
}
